import { render, staticRenderFns } from "./PaRent.vue?vue&type=template&id=255b8f7e&"
import script from "./PaRent.vue?vue&type=script&lang=js&"
export * from "./PaRent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports